<template>
  <div class="wrapper">
    <FormList
      :list="userInfoList"
      :data="loginParams"
      :onChange="onInputChange"
    />
    <div class="code-wrp">
      <FormList
        :list="codeList"
        :data="loginParams"
        :onChange="onInputChange"
      />
      <van-button class="get-code" plain type="info" @click="canClick ? sendCode() : null">{{buttonTitle}}</van-button>
    </div>
    <p class="error-message">{{errorText}}</p>
    <div class="footer">
      <van-button
        class="btn"
        :loading="isLoading"
        type="info"
        loading-text="登录中..."
        @click="login"
      >
        登录电子税局
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Field,
  CellGroup,
  Button,
  Notify,
  Toast
} from 'vant'
import { mapActions, mapState, mapMutations } from 'vuex'
import FormList from '@components/FormList'
import { isMobileNo } from '@utils/basicUtil'
import { invoiceRequest } from '@/services'
const namespace = 'eTaxLogin'
export default {
  components: {
    FormList,
    [Row.name]: Row,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  props: {
    getLoginResults: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      isPhone: false,
      buttonTitle: '获取验证码',
      canClick: true,
      timer: null,
      isLoading: false,
      errorVisible: false,
      errorText: '',
      userInfoList: [
        {
          type: 'text',
          field: 'taxPersonnelPhone',
          label: '手机账号',
          placeholder: '--',
          readonly: true
        }
      ],
      codeList: [
        {
          type: 'text',
          field: 'smsCode',
          label: '短信验证',
          placeholder: '请输入短信验证码'
        }
      ],
      loginParams: {
        smsCode: '',
      },
      sid: '',
      countDown: 60
    }
  },
  computed: {
    ...mapState(namespace, ['certificationResults']),
  },
  watch: {},
  created () {},
  async mounted () {
    // this.setCertificationResults({})
    await this.getAuthInfo()
    this.onInputChange({ field: 'taxPersonnelPhone', e: this.certificationResults.taxPersonnelPhone})
    console.log(this.certificationResults)
    await this.reLoginETaxBySmsCode()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  activated () {},
  updated () {},
  methods: {
    ...mapActions(namespace, ['getAuthInfo']),
    onInputChange ({ e, field }) {
      this.loginParams = {
        ...this.loginParams,
        [field]: e
      }
    },
    testPhone () {
      if (!/^1[34578]\d{9}$/.test(this.editData.phone.trim())) {
        Notify({ type: 'danger', message: '手机号格式不正确' })
      } else {
        this.isPhone = true
      }
    },
    createCountDown() {
      let cd = 60
        this.timer = null

        this.timer = setInterval(() => {
          cd--
          this.countDown = cd
          this.buttonTitle = this.countDown + '秒后重试'
          this.canClick = false
          if (cd === 0) {
            this.countDown = 60
            clearInterval(this.timer)
            this.canClick = true
            this.buttonTitle = '发送验证码'
          }
        }, 1000)
    },
    async getSmsVerifyCode () {
      Toast.loading({
        message: '请求中...',
        forbidClick: true,
        duration: 0
      })
      const res = await invoiceRequest.allElectricLogin.asyncAutonomousLogin({
        loginType: 0,
        sid: this.sid
      })
      if (res.success) {
        if (res.result.status === 1) {// 登录成功，需要查左上角接口，获取最新登录时间
          Notify({ type: 'success', message: '登录成功' })
          this.getLoginResults()
        } else if (res.result.status === 2) { // 登录失败
          this.errorVisible = true
          this.errorText = res.result.message
          this.sid = res.result.sid
          Notify({ type: 'danger', message: res.result.message })
        } else if (res.result.status === 3) { // 短信已发送
          Notify({ type: 'success', message: '短信验证码已发送，请注意查收！' })
          this.onInputChange({ field: 'smsCode', e: ''})
          this.currentInfo = {}
          this.sid = res.result.sid
          this.createCountDown()
        }
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
      Toast.clear()
    },
    async sendCode () {
      const { countDown, loginParams } = this
      console.log(loginParams.taxPersonnelPhone)
      if (countDown === 60 && isMobileNo(loginParams.taxPersonnelPhone)) {
        this.getSmsVerifyCode()
      } else if (!isMobileNo(loginParams.taxPersonnelPhone)) {
        Notify({ type: 'danger', message: '请输入正确的手机号' })
      }
    },
    async reLoginETaxBySmsCode() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const res = await invoiceRequest.allElectricLogin.asyncAutonomousLogin({
        loginType: 0,
        sid: this.sid
      })
      if (res.success) {
        if (res.result.status === 1) {// 登录成功，需要查左上角接口，获取最新登录时间
          Notify({ type: 'success', message: '登录成功' })
          this.getLoginResults()
        } else if (res.result.status === 2) { // 登录失败
          this.errorVisible = true
          this.errorText = res.result.message
          this.sid = res.result.sid
          Notify({ type: 'danger', message: res.result.message })
        } else if (res.result.status === 3) { // 短信已发送
          Notify({ type: 'success', message: '短信验证码已发送，请注意查收！' })
          this.onInputChange({ field: 'smsCode', e: ''})
          this.currentInfo = {}
          this.sid = res.result.sid
          this.createCountDown()
        }
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
      Toast.clear()
    },
    /**
     * 短信登录接口
     * result 1、是否需要短信验证码，需要就跳到 输入验证码页面
     * 不需要的话， 成功即成功， 失败即失败
     */
    async login() {
      Toast.loading({
        message: '登录中...',
        forbidClick: true,
        duration: 0
      })
      const loginParams = this.loginParams
      console.log(loginParams, 'loginParams')
      if (!loginParams.smsCode) {
        Toast.clear()
        Notify({ type: 'danger', message: '请输入验证码' })
        return
      }
      this.isLoading = true
      const res = await invoiceRequest.allElectricLogin.asyncSubmitSms({
        loginType: 0,
        smsCode: loginParams.smsCode,
        sid: this.sid
      })
      if (res.success) {
        if (res.result.status === 1) { //1、登录成功 2、登录失败（需要根据异常提示是否继续进行）
          Notify({ type: 'success', message: '登录成功' })
          this.getLoginResults()
        } else { // 需要输入验证码
          this.errorVisible = true
          this.errorText = res.result.message
          this.sid = res.result.sid
          Notify({ type: 'danger', message: res.result.message })
        }
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
      this.isLoading = false
      Toast.clear()
    }
  }
}
</script>
<style scoped lang='less'>
  .code-wrp{
    position: relative;
    border-top: 1PX solid #edf2f6;
    border-bottom: 1PX solid #edf2f6;
    box-sizing: border-box;
  }
 .get-code {
    width: 180px;
    height: 54px;
    font-size: 24px;
    border-radius: 5px;
    position: absolute;
    right: 0;
    bottom: 20px;
    border: 0;
  }
  .error-message{
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #F65440;
    line-height: 34px;
    text-align: left;
  }
  .footer{
    margin-top: 48px;
    padding: 0 24px;
    display: flex;
    box-sizing: border-box;
    .btn{
      padding: 16px 0;
      width: 100%;
      height: 100%;
      border-radius: 40px;
      font-size: 32px;
    }
  }
</style>
